// extracted by mini-css-extract-plugin
export var downArrow = "_7t-0";
export var label = "_7t-1";
export var treatmentCard = "_7t-3";
export var upArrow = "_7t-2";